module.exports = "/_next/static/images/RichCustomerProfiles-3f54bc65156aa3525571c79c202d3e04.webp";